import React, { useState } from "react";
import { connect } from "react-redux";
import { dealjacketActions } from "../../actions";
import { OrgDropdown } from "../org/OrgDropdown"

function EditDeal(props) {

    const {
        org_id,
        dealjacket_id,
        dealjacket_name,
        toggleEditName,
        editDealJacketName,
        setJacketName
    } = props;

    const [newName, setNewName] = useState(dealjacket_name);
    const [newOrgId, setNewOrgId] = useState(org_id);

    const handleNameChange = (e) => {
        const name = e.target.value;
        setNewName(name);
    };

    const submitRequest = (e) => {
        if (newName?.length > 0) {
            var request = {
                deal_jacket_id: dealjacket_id,
                name: newName,
                org_id: org_id,
                new_org_id: newOrgId
            };
            editDealJacketName(request);
            setJacketName(newName);
            toggleEditName();
        }
    };

    const handleOrgChange = (event) => {
        const new_org_id = event.target.value;
        setNewOrgId(new_org_id);
      };

    return (
        <div className="classifyDeal">
            <div className="classifyForm">
                <form className="ingestorForm">
                    <table className="classifyFormTable">
                        <tbody>
                        <tr><td colSpan="2"><h3>Deal Jacket Editor</h3></td></tr>
                        <tr><td colSpan="2"><hr /></td></tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>
                        <tr>
                            <td className="formLabel"><label htmlFor="dealName">Name:</label></td>
                            <td className="formInfo">
                                <input className="dealNameInput"
                                    autoComplete="off"
                                    type="text"
                                    name="dealName"
                                    id="dealName"
                                    value={newName}
                                    onChange={handleNameChange}
                                ></input>
                            </td>
                        </tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>                        
                        <tr><td colSpan="2"><hr /></td></tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>                        
                        <tr>
                            <td className="formLabel"><label>Org:</label></td>
                            <td className="formInfo">
                                <OrgDropdown handler={handleOrgChange} prepop={newOrgId}/>
                            </td>
                        </tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>                        
                        <tr><td colSpan="2"><hr /></td></tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>
                        <tr colSpan="2">
                            <td colSpan="2" align="center">
                                <span
                                    id="save"
                                    className="classifyFormButton"
                                    name="saveButton"
                                    onClick={submitRequest}
                                >
                                    Save
                                </span>
                                <span
                                    id="cancel"
                                    className="classifyFormButton"
                                    name="cancelButton"
                                    onClick={toggleEditName}
                                >
                                    Cancel
                                </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </form>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    const { ingestion } = state;
    return {
      ingestion,
    };
  }
  
  const actionCreators = {
    editDealJacketName: dealjacketActions.editJacketName,
  };
  
  const connectedEditDeal = connect(
    mapStateToProps,
    actionCreators
  )(EditDeal);
  export { connectedEditDeal as EditDeal };
